import { StoreConstant } from '../constants';

export const reset = () => ({
  type: StoreConstant.RESET_STORE,
});
